import * as React from 'react';
type Props = {
  className?: string;
};
export function Bookmark({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-bookmark"
      className={className}
    >
      <path
        d="M12.6178 17.7137C12.2552 17.4288 11.7448 17.4288 11.3822 17.7137L7.61782 20.6714C6.96169 21.1869 6 20.7195 6 19.8851V5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V19.8851C18 20.7195 17.0383 21.1869 16.3822 20.6714L12.6178 17.7137Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
